import { Form } from "antd";
import dayjs from "dayjs";
import FormHeaderTitle from "../../Invoice(Visa)/Components/FormHeaderTitle";
import { IHajiInformation } from "../Types/InvoiceHajjiPre.Types";
import { FormInstance } from "antd/lib/form";
import HajjDetails_List_Info from "./HajjDetails_List_Info";

const HajiInformation = ({
  value,
  form,
}: {
  value?: IHajiInformation[];
  form?: FormInstance<any>;
}) => {
  const initialValue = value?.map((item) => {
    return {
      hajiinfo_name: item.hajiinfo_name,
      haji_info_id: item.haji_info_id,
      hajiinfo_tracking_number: item.hajiinfo_tracking_number,
      hajiinfo_nid: item.hajiinfo_nid,
      hajiinfo_serial: item.hajiinfo_serial,
      haji_info_maharam: item.haji_info_maharam,
      haji_info_vouchar_no: item.haji_info_vouchar_no,
      hajiinfo_mobile: item.hajiinfo_mobile,
      hajiinfo_gender: item.hajiinfo_gender,
      haji_info_possible_year: item.haji_info_possible_year
        ? dayjs(item.haji_info_possible_year)
        : undefined,
      haji_info_reg_year: dayjs(item.haji_info_reg_year),
      hajiinfo_dob: item.hajiinfo_dob ? dayjs(item.hajiinfo_dob) : undefined,
    };
  });

  return (
    <div className="border p-5 my-20">
      <FormHeaderTitle title="Haji Information 🕌" />
      <Form.List
        name="haji_information"
        initialValue={
          initialValue ? initialValue : [{ haji_info_reg_year: dayjs() }]
        }
      >
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }, index) => (
              <HajjDetails_List_Info
                key={key}
                name={name}
                index={index}
                value={value}
                add={add}
                remove={remove}
                form={form}
              />
            ))}
          </>
        )}
      </Form.List>
    </div>
  );
};

export default HajiInformation;
